var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.disabled)?_c('span',{class:_vm.disabledButtonClasses},[_c('i',{staticClass:"fas fa-trash"})]):_vm._e(),_vm._v(" "),(!_vm.disabled)?_c('call-dialog-link',{attrs:{"id":_vm.id,"route":_vm.route,"message":_vm.message,"css-class":_vm.buttonClasses}},[_c('i',{staticClass:"fas fa-trash"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }